import { useCallback } from "react";
import { Button, Tooltip } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

function AnnouncementEditButton({ messageId }) {
  const navigate = useNavigate();
  const clickHandler = useCallback(() => {
    navigate(`/workshop/announce/form/${messageId}`);
  }, [navigate, messageId]);

  return (
    <Tooltip title="修改">
      <Button size="small" icon={<EditOutlined />} onClick={clickHandler} />
    </Tooltip>
  );
}

export default AnnouncementEditButton;
